import { DOCUMENT } from '@angular/common';
import {Component, HostListener, Inject, Input, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractComponent, FileType, PanelComponent } from '@components';
import {
  CategoryItem,
  CompetitorFilter,
  CompetitorResults,
  DEFAULT_PAGE_INDEX,
  EventItem,
  Lookups,
  PagedFilter,
  Pages,
  Race,
} from '@model';
import { TranslocoService } from '@ngneat/transloco';
import {CompetitorResultsService, ExportService} from '@services';
import {forkJoin} from "rxjs";

@Component({
    selector: 'app-race-results-list-component',
    templateUrl: './race-results-list-component.component.html',
    styleUrls: ['./race-results-list-component.component.scss'],
    standalone: false
})
export class RaceResultsListComponentComponent extends AbstractComponent implements OnInit{
  @Input() race?: Race;
  @Input() genders: Lookups[] = [];
  @Input() results: CompetitorResults[] = [];
  @Input() eventItem?: EventItem;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() categories: CategoryItem[] = [];
  @Input() showRaceNameInTable: boolean = false;
  @Input() loadOnInit: boolean = false;

  @ViewChild("importPanel") importPanel?: PanelComponent;

  showFabButton = false;
  selectedFile?: string;
  gender?: number;
  page = DEFAULT_PAGE_INDEX;
  name?: string;
  category?: number;
  hasMore = false;
  filter?: PagedFilter<CompetitorFilter>;
  isLoading: boolean = false;

  constructor(
    public translocoService: TranslocoService,
    @Inject(DOCUMENT) private document: Document,
    private exportService: ExportService,
    private route: ActivatedRoute,
    private competitorResultsService: CompetitorResultsService,
  ) {
    super();
  }

  ngOnInit() {
    if (this.loadOnInit) {
      this.loadResults();
    }
  }

  loadResults() {
    let competitorFilter: CompetitorFilter = new CompetitorFilter();
    competitorFilter.raceId = this.race?.id ?? this.eventItem!.racesList![0].id;
    competitorFilter.eventId = this.eventItem!.id;

    this.isLoading = true;
    const categoriesRequest = this.competitorResultsService.findCategoryItemsByRaceId(
        this.race?.id ?? this.eventItem!.racesList![0].id!
    );
    const resultsRequest = this.competitorResultsService.getCompetitorResults(
        new PagedFilter(new Pages(), competitorFilter),
        true
    );

    forkJoin([resultsRequest, categoriesRequest]).subscribe({
      next: ([results, categories]: [CompetitorResults[], CategoryItem[]]) => {
        this.results = [...results];
        this.categories = [...categories];
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }


  handleFilterChange(filter: PagedFilter<CompetitorFilter>): void {
    this.filter = filter;
  }

  @HostListener('window:scroll')
  toggleFabButton(): void {
    this.showFabButton = window.pageYOffset !== 0;
  }

  scrollToTop(): void {
    this.document.body.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
  }

  importResultList() {
    // todo
  }

  initImportParams() {
    // todo
  }

  exportCompetitorResultsList(type: string) {
    if (!this.filter) {
      const filter = new CompetitorFilter();
      if (this.category) filter.categories = [this.category];
      filter.gender = this.gender;
      filter.name = this.name;
      filter.eventId = +this.route.snapshot.queryParams['eventId'];
      filter.raceId = +this.route.snapshot.queryParams['raceId'];
      this.filter = new PagedFilter(new Pages(undefined, this.page), filter);
    }
    this.exportService.downloadResultsForRace(type, this.filter);
  }

  padNumber(num: number, size: number): string {
    return num.toString().padStart(size, '0');
  }

  resultsFileAdded(file?: string) {
    this.selectedFile = file;
  }

  onImportPanelCancel() {
    this.selectedFile = undefined;
    this.importPanel?.closeDropdown();
  }

  onImportPanelSave() {
    // todo
  }

  protected readonly FileType = FileType;
}
